let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aIlQC"), load("1dyEV")]).then(() => parcelRequire('hMkTx'));